<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div class="form-fieldhelp" v-if="!isIndividualOrganizationSubject && !isFizOrganizationSubject">
      <label>?</label>
      <div class="form-fieldhelp-text">
        <div>Наименование организации, от имени которой подается заявка</div>
      </div>
    </div>
    <div v-if="form.organization.innError" class="form-fielderror">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>{{ form.organization.innHint }}</div>
      </div>
    </div>
    <label class="col-form-label">{{ organizationNameInputLabel }}</label>
    <typeahead
      type="text"
      class="first-upper"
      id="form-organization-name"
      autocomplete="off"
      :disabled="disabled"
      v-model="inputValue"
      @change="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
      @hit="selectTypeahead"
      :data="data"
      :serializer="this.serializeData"
      :maxMatches="typeaheadLimit"
    >
      <template v-slot:suggestion="{data, htmlText}">
        {{data.value}}
        <template v-if="!isFizOrganizationSubject && data && data.data">
          <template v-if="data.isInn">
            <div v-html="htmlText"></div>
          </template>
          <template v-else>
            <div>{{ data.data.inn }}</div>
          </template>

          <div v-if="data.data.address">{{ data.data.address.value }}</div>
        </template>
      </template>
    </typeahead>
    <a
      v-if="!isCheck && !isView && !disabled"
      @click="emit($event, 'switch-location-name')"
      class="transport-owner-helpers"
    >{{ locationName === 'all' ? 'Северо-Западный ФО' : 'Без ограничений' }}</a>
    <error-help-block :has-errors="hasInputErrors" :current-error="inputError"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationNameInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputName: {
      default: 'name'
    },

    locationName: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      data: []
    }
  },

  computed: {
    organizationNameInputLabel () {
      if (this.inputLabel) {
        return this.inputLabel
      }

      return this.isEntityOrganizationSubject
        ? 'Наименование организации'
        : 'Фамилия, имя, отчество'
    }
  },

  methods: {
    serializeData (item) {
      let result = item.value
      item.isInn = false

      if (item.data.inn.indexOf(this.inputValue) !== -1) {
        result = item.data.inn
        item.isInn = true
      }

      return result
    }
  }
}
</script>
